import { render, staticRenderFns } from "./ItemElementMenu.vue?vue&type=template&id=36ed3a24&scoped=true"
import script from "./ItemElementMenu.vue?vue&type=script&lang=ts"
export * from "./ItemElementMenu.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementMenu.vue?vue&type=style&index=0&id=36ed3a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed3a24",
  null
  
)

export default component.exports